import { useEffect, useState } from 'react'

import { access } from '@driftt/traffic-control'

import { AccountActivityApi } from '../api'
import { captureException } from '../utils/sentry'

import { getInitialSavedFilterValues } from './useFormValues'

type setter = (field: string, value: any, shouldValidate?: boolean) => void

export default function useFilterSets(savedFilterIdParam?: number, setFieldValue?: setter) {
  const [loadingAccountActivity, setLoadingAccountActivity] = useState(false)
  const [savedFilters, setSavedFilters] = useState([])
  const [savedFiltersFailed, setSavedFiltersFailed] = useState(false)
  const [selectedAccountFilter, setSelectedAccountFilter] = useState(undefined)

  const hasCustomAccountActivityNotifs = access.hasGates(
    'account_activity_email_digest',
    'saved_filters_push_notifications'
  )

  const fetchFilterSets = () => {
    setLoadingAccountActivity(true)
    setSavedFiltersFailed(false)

    AccountActivityApi.get('/v2/filter_sets')
      .then(({ data }: any) => {
        setSavedFilters(data.savedFilterSets)
      })
      .catch((error: any) => {
        setSavedFiltersFailed(true)
        captureException(error, { tags: { location: 'fetchAccountActivity-notificationSettings' } })
      })
      .finally(() => {
        setLoadingAccountActivity(false)
      })
  }

  useEffect(() => {
    if (hasCustomAccountActivityNotifs) {
      fetchFilterSets()
    }
  }, [hasCustomAccountActivityNotifs])

  useEffect(() => {
    const selectedFilter = savedFilters.find(
      (filter: Record<string, any>) => filter.id === savedFilterIdParam
    )
    setSelectedAccountFilter(selectedFilter)
  }, [savedFilters, savedFilterIdParam])

  useEffect(() => {
    if (setFieldValue) {
      const initialSavedFilterSettings = getInitialSavedFilterValues(savedFilters)
      setFieldValue('savedFilters', initialSavedFilterSettings)
    }
  }, [savedFilters, setFieldValue])

  return {
    loadingAccountActivity,
    savedFilters,
    savedFiltersFailed,
    selectedAccountFilter,
    hasCustomAccountActivityNotifs,
    setSelectedAccountFilter,
    fetchFilterSets
  }
}
